import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { pxToRem } from 'utils/ui';
import ButtonCore from 'components/ButtonCore';
import VisuallyHidden from 'components/VisuallyHidden';
import { jsx as _jsx } from "react/jsx-runtime";
var ButtonWrapper = styled(ButtonCore).withConfig({
  displayName: "RowSelectButton__ButtonWrapper",
  componentId: "sc-1x74tu4-0"
})(["position:absolute;left:0;top:0;bottom:0;width:", ";background-color:", ";opacity:0;tr:first-child &{border-top-left-radius:inherit;}tr:last-child &{border-bottom-left-radius:inherit;}&:focus{outline:none;}tr[aria-selected='true'] &&{opacity:1;}tr[data-highlighted] &&[data-focus-visible-added]{opacity:1;}"], pxToRem(4), function (p) {
  return p.theme.links;
});
var RowSelectButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ButtonWrapper, _objectSpread(_objectSpread({
    ref: ref
  }, otherProps), {}, {
    children: /*#__PURE__*/_jsx(VisuallyHidden, {
      children: children
    })
  }));
});
RowSelectButton.displayName = 'RowSelectButton';
export default RowSelectButton;